module.exports = __webpack_public_path__ + "static/media/AD814B76-3AAE-4422-B9A0-42E0DBA2AE2D.74586d61.JPG";